import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Account } from './pages/account/Account';
import { Addresses } from './pages/account/Addresses';
import { Loyalty } from './pages/account/Loyalty';
import { Offers } from './pages/account/Offers';
import { OrderDetail } from './pages/account/OrderDetail';
import { Profile } from './pages/account/Profile';
import { Book } from './pages/bookings/Book';
import { BookingDetail } from './pages/bookings/BookingDetail';
import { MyBookings } from './pages/bookings/MyBookings';
import { Checkout } from './pages/Checkout';
import { MyOrders } from './pages/MyOrders';
import { TableWelcome } from './pages/TableWelcome';
import { NeedsStore } from './pages/NeedsStore';
import { Storefront } from './pages/Storefront';
import { Track } from './pages/Track';
import './styles/tokens.css';
import './styles/storefront.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NeedsStore />} />
        <Route path="/r/:rid/s/:sid" element={<Storefront />} />
        <Route path="/r/:rid/s/:sid/checkout" element={<Checkout />} />
        <Route path="/r/:rid/s/:sid/track/:orderId" element={<Track />} />
        <Route path="/r/:rid/s/:sid/t/:tableId" element={<TableWelcome />} />
        <Route path="/r/:rid/s/:sid/orders" element={<MyOrders />} />
        <Route path="/r/:rid/s/:sid/orders/:orderId" element={<OrderDetail />} />
        <Route path="/r/:rid/s/:sid/account" element={<Account />} />
        <Route path="/r/:rid/s/:sid/account/profile" element={<Profile />} />
        <Route path="/r/:rid/s/:sid/account/addresses" element={<Addresses />} />
        <Route path="/r/:rid/s/:sid/account/loyalty" element={<Loyalty />} />
        <Route path="/r/:rid/s/:sid/account/offers" element={<Offers />} />
        <Route path="/r/:rid/s/:sid/book" element={<Book />} />
        <Route path="/r/:rid/s/:sid/bookings" element={<MyBookings />} />
        <Route path="/r/:rid/s/:sid/bookings/:bookingId" element={<BookingDetail />} />
        <Route path="*" element={<NeedsStore />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
